<template>
  <section class="development-process position-relative see__pad">
    <div class="pattern-layer">
      <div
        class="pattern-1 position-absolute"
        style="background-image: url('/shapes/shape-07.png')"
      ></div>
    </div>
    <div class="pattern-layer">
      <div
        class="pattern-2 position-absolute"
        style="background-image: url('/shapes/shape-08.png')"
      ></div>
    </div>
    <div class="pattern-layer">
      <div
        class="pattern-3 position-absolute"
        style="background-image: url('/shapes/shape-09.png')"
      ></div>
    </div>
    <div class="pattern-layer">
      <div
        class="pattern-4 position-absolute"
        style="background-image: url('/shapes/shape-10.png')"
      ></div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="process-header text-center">
            <div class="process-section-label">
              <h4>{{ content.sectionLabel }}</h4>
            </div>
            <div class="process-main-title">
              <h2>{{ content.sectionTitle }} <span>{{ content.sectionTitleHighlight }}</span></h2>
            </div>
            <div class="process-description">
              <p>{{ content.sectionDescription }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="process-timeline">
        <div 
          class="process-step"
          v-for="(step, index) in content.steps"
          :key="index"
        >
          <div class="step-number">{{ step.number }}</div>
          <div class="step-content">
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SynergyItsProcessComp",
  props: {
    content: {
      type: Object,
      required: true,
      default: () => ({
        sectionLabel: "Sogdo's Edge",
        sectionTitle: "What Sets Us",
        sectionTitleHighlight: "Apart",
        sectionDescription: "Our unique approach combines industry expertise, cutting-edge technology, and proven methodologies to deliver exceptional results.",
        steps: [
          {
            number: "01",
            title: "Industry-Specific Teams",
            description: "Dedicated teams with deep expertise in each industry vertical, ensuring solutions that truly understand your business domain and challenges."
          },
          {
            number: "02",
            title: "Modular, Scalable Platforms",
            description: "Built with modularity in mind, our platforms can scale seamlessly as your business grows, adapting to changing requirements and increasing demands."
          },
          {
            number: "03",
            title: "Integration with APIs & Legacy Systems",
            description: "Seamless integration capabilities that work with your existing systems, APIs, and legacy infrastructure, minimizing disruption and maximizing value."
          },
          {
            number: "04",
            title: "Built for Speed & Scale",
            description: "Architecture and development practices optimized for rapid deployment and enterprise-scale performance, ensuring your solutions can handle growth."
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

/* Import Flaticon */
@import "@/assets/scss/Flaticon.scss";

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}

.pattern-1 {
  bottom: 25%;
  right: 20%;
  width: 70px;
  height: 70px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-2 {
  top: 40%;
  left: 5%;
  width: 110px;
  height: 110px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.09;
}

.pattern-3 {
  bottom: 15%;
  left: 12%;
  width: 85px;
  height: 85px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-4 {
  top: 35%;
  right: 8%;
  width: 95px;
  height: 95px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

/* Development Process Section */
.development-process {
  background: #00061a;
  position: relative;
  overflow: hidden;
}

.process-header {
  margin-bottom: 60px;
}

.process-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #f6ec4f;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
  text-transform: uppercase;
}

.process-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
}

.process-main-title h2 span {
  color: #f6ec4f;
}

.process-description p {
  font-size: 18px;
  line-height: 28px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  font-family: "Open Sans", sans-serif;
}

.process-timeline {
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 50px;
}

.process-step {
  display: flex;
  align-items: flex-start;
  gap: 30px;
  padding: 30px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  border: 1px solid rgba(246, 236, 79, 0.1);
  transition: all 0.3s ease;
}

.process-step:hover {
  border-color: #f6ec4f;
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-5px);
}

.step-number {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  background: #f6ec4f;
  color: #00061a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  font-family: "Archivo", sans-serif;
  margin-right: 20px;
}

.step-content h3 {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  font-family: "Archivo", sans-serif;
}

.step-content p {
  font-size: 16px;
  line-height: 26px;
  color: #fff;
  margin-bottom: 0;
  font-family: "Open Sans", sans-serif;
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .see__pad {
    padding: 80px 0;
  }
  
  .process-timeline {
    gap: 30px;
  }
  
  .process-step {
    padding: 25px;
  }
}

@media only screen and (max-width: 767px) {
  .see__pad {
    padding: 60px 0;
  }

  .process-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }

  .process-step {
    flex-direction: column;
    text-align: center;
    padding: 20px;
  }

  .step-number {
    margin-right: 0;
    margin-bottom: 20px;
  }

  .pattern-1,
  .pattern-2,
  .pattern-3,
  .pattern-4 {
    opacity: 0.05;
  }
}

@media only screen and (max-width: 399px) {
  .see__pad {
    padding: 40px 0;
  }

  .process-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }

  .process-section-label h4 {
    font-size: 16px;
    letter-spacing: 8px;
  }

  .process-step {
    padding: 20px;
  }
}
</style>
